import React, { useState, useEffect, useRef } from 'react';

//import para inicio de sesion y consultas
import { onAuthStateChanged } from 'firebase/auth';
import { auth, getUserInfo } from '../../firebase/firebase';

//import para ver permisos
import { hasPermission } from '../../firebase/permisos';

//import para navigate
import { useNavigate } from 'react-router-dom';

//importacion del MENU
import Menu from '../menu';
import HeaderHome from '../header';

//import para funciones especificas de esta pantalla
import { getAllUsers, getRoles, deleteUserAccount, deleteMultipleUserAccounts } from '../../firebase/usuarios_roles';

import { Link } from 'react-router-dom';

//modal de carga
import LoadingModal from '../Loading-Modal/loading.jsx'


//import de iconos
import { AiFillCloseCircle } from 'react-icons/ai';
import { CiMenuKebab } from 'react-icons/ci';
import { GrFormEdit } from 'react-icons/gr';
import { FiTrash2 } from 'react-icons/fi';
import { MdArrowBackIosNew, MdArrowForwardIos } from 'react-icons/md';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';


import Modal from '../Modal/Modal.jsx'
import './usuarios.css';

function Usuarios(props) {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false); // Estado para controlar el modal de carga


    const [useUser, setUseUser] = useState({
        nombre: '',
        rol: '',
        email: '',
        genero: '',
        fechaIni: '',
        cumple: '',
        tel: '',
        foto: ''
    });

    const [loading, setLoading] = useState(true);
    const hasCheckedPermission = useState(false);
    const [users, setUsers] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState({});

    //Estado para manejar el listado de roles a mostrar en el Dropdown
    const [roles, setRoles] = useState([]);

    // Estado para rastrear qué usuarios han sido seleccionados
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectAll, setSelectAll] = useState(false); // Estado para el checkbox de la cabecera



    const toggleDropdown = (userId) => {
        setDropdownOpen(prevState => ({
            ...prevState,
            [userId]: !prevState[userId]
        }));
    };

    const dropdownRef = useRef(null);

    //AQUI ESTA EL MODAL
    const [showModal, setShowModal] = useState(false);
    const [showModalForUserId, setShowModalForUserId] = useState(null);

    const [showMultiDeleteModal, setShowMultiDeleteModal] = useState(false);


    const handleTrashClick = (userId) => {
        setShowModalForUserId(userId);
    };
    //AQUI TERMINA EL MODAL

    useEffect(() => {
        if (!hasCheckedPermission.current) {
            onAuthStateChanged(auth, handleUserStateChanged);
            hasCheckedPermission.current = true;
        }

        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                if (event.target.className !== 'dontCloseDropdown' && !showModal) {
                    setDropdownOpen({});
                }
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, []);


    async function handleUserStateChanged(user) {
        if (user) {
            setIsLoading(true);
            try {
                const res = await getUserInfo(user.uid);
                if (res != null) {
                    setUseUser(prevState => ({
                        ...prevState,
                        nombre: res.nombre,
                        rol: res.rol,
                        email: res.email,
                        genero: res.genero,
                        fechaIni: res.fechaIni.toDate().toLocaleDateString(),
                        cumple: res.cumple.toDate().toLocaleDateString(),
                        tel: res.tel,
                        foto: res.foto
                    }));

                    //cargar los roles
                    const fetchedRoles = await getRoles();
                    setRoles(fetchedRoles);

                    setLoading(false); // para saber si termino de cargar los datos del usuario

                    const canAccess = await hasPermission(res.rol, "permisos/usuarios");
                    if (!canAccess) {
                        props.showErr('Usted no tiene permisos para acceder a esta función.')
                        navigate('/home');
                        return;
                    }

                    setUsers(await getAllUsers());

                } else {
                    setUseUser(prevState => ({
                        ...prevState,
                        nombre: 'N/A',
                        rol: 'N/A',
                        email: 'N/A',
                        genero: 'N/A',
                        fechaIni: 'N/A',
                        cumple: 'N/A',
                        tel: 'N/A',
                        foto: 'N/A'
                    }));
                }
                setIsLoading(false);
            } catch {
                console.log('NO HAY USUARIO :(');
                navigate('/login');
            }
        } else {
            navigate('/login');
        }
    }


    function formatDate(date) {
        // Si date es un Timestamp de Firebase, convertirlo a un objeto Date
        const jsDate = date.toDate ? date.toDate() : date;
        const now = new Date();
        const diffMs = now - jsDate; // Diferencia en milisegundos
        const diffSec = diffMs / 1000; // Diferencia en segundos
        const diffMin = Math.floor(diffSec / 60); // Diferencia en minutos
        const diffHour = Math.floor(diffMin / 60); // Diferencia en horas
        const diffDay = Math.floor(diffHour / 24); // Diferencia en días
        const diffWeek = Math.floor(diffDay / 7); // Diferencia en semanas

        if (diffMin < 1) return "Hace menos de un minuto";
        if (diffMin === 1) return "Hace un minuto";
        if (diffMin < 60) return `Hace ${diffMin} minutos`;
        if (diffHour === 1) return "Hace una hora";
        if (diffHour < 24) return `Hace ${diffHour} horas`;
        if (diffDay === 1) return "Hace un día";
        if (diffDay < 7) return `Hace ${diffDay} días`;
        if (diffWeek === 1) return "Hace una semana";
        if (diffWeek < 2) return `Hace ${diffWeek} semanas`;
        return "Hace mucho tiempo";
    }

    //AQUI ESTA EL PAGINADOR
    const [currentPage, setCurrentPage] = useState(() => {
        const savedPage = localStorage.getItem('currentPageUsuarios');
        return savedPage ? Number(savedPage) : 1;
    });
    const [itemsPerPage] = useState(4);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const [totalPages, setTotalPages] = useState(0);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        localStorage.setItem('currentPageUsuarios', pageNumber);
    };
    const [searchName, setSearchName] = useState('');
    const [searchEmail, setSearchEmail] = useState('');
    const [searchRole, setSearchRole] = useState('');


    const InputChangeUsr = (event) => {
        const { name, value } = event.target;
        if (name === 'nombre') {
            setSearchName(value);
        } else if (name === 'email') {
            setSearchEmail(value);
        } else if (name === 'rol') {
            setSearchRole(value);
        }
        if (value) {
            document.getElementById(name).classList.add('input-active');
        } else {
            document.getElementById(name).classList.remove('input-active');
        }

        // Guardar los filtros actualizados en localStorage
        saveFiltersToLocalStorage({
            searchName: name === 'nombre' ? value : searchName,
            searchEmail: name === 'email' ? value : searchEmail,
            searchRole: name === 'rol' ? value : searchRole
        });
        setExecutionCount(prevCount => prevCount + 1); // Incrementa el contador
    };


    const filteredUsers = users.filter(user => {
        return (
            user.nombre.toLowerCase().includes(searchName.toLowerCase()) &&
            user.email.toLowerCase().includes(searchEmail.toLowerCase()) &&
            (searchRole === '' || user.rol === searchRole)
        );
    });

    useEffect(() => {
        setTotalPages(Math.ceil(filteredUsers.length / itemsPerPage));
    }, [filteredUsers, itemsPerPage]);

    const [executionCount, setExecutionCount] = useState(0);

    //Restaurar los Filtros desde localStorage al Cargar la Página
    useEffect(() => {
        const savedFilters = JSON.parse(localStorage.getItem('filtersUsuarios'));
        if (savedFilters) {
            setSearchName(savedFilters.searchName || '');
            setSearchEmail(savedFilters.searchEmail || '');
            setSearchRole(savedFilters.searchRole || '');
            setSelectedRole(savedFilters.selectedRole || '');
        }

        const savedPage = localStorage.getItem('currentPageUsuarios');

        if (savedPage) {
            setCurrentPage(Number(savedPage));
        }

    }, []);

    useEffect(() => {
        setExecutionCount(prevCount => prevCount + 1); // Incrementa el contador

        const lastURL = localStorage.getItem('lastURL');
        if ((executionCount >= 3) || (lastURL != 'permisos/usuarios')) {
            setCurrentPage(1);
            localStorage.setItem('currentPageUsuarios', 1);
            localStorage.setItem('lastURL', 'permisos/usuarios');
        }
    }, [searchName, searchEmail, searchRole]);

    //SECCION PARA MANEJAR HISTORIAL EN FILTROS POR LOCALSTORAGE

    //Guardar los Filtros en localStorage
    const saveFiltersToLocalStorage = (filters) => {
        localStorage.setItem('filtersUsuarios', JSON.stringify(filters));
    };

    const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);


    const [isRoleOpen, setRoleOpen] = useState(false);
    const [selectedRole, setSelectedRole] = useState("");

    const handleRoleChange = (role) => {

        if (role === '') {
            setSelectedRole('Selecciona un rol');
            setSearchRole('');
        } else {
            setSelectedRole(role);
            setSearchRole(role);
        }

        setRoleOpen(false);

        // Guardar los filtros actualizados en localStorage
        saveFiltersToLocalStorage({
            searchName,
            searchEmail,
            searchRole: role,
            selectedRole: role
        });
        setExecutionCount(prevCount => prevCount + 1); // Incrementa el contador

    };

    // Efecto para manejar el clic fuera del menú
    useEffect(() => {
        function handleDocumentClick(event) {


            // Verificar si el clic es fuera del menú de roles
            if (isRoleOpen && !event.target.closest('.field-container-usuarios')) {
                setRoleOpen(false);
            }

        }

        document.addEventListener('mousedown', handleDocumentClick);

        return () => {
            document.removeEventListener('mousedown', handleDocumentClick);
        };
    }, [isRoleOpen]); // Dependencias del efecto



    const goToEditUser = (userSel) => {
        navigate('./editar', { state: { userSel } });
    };

    const deleteUsers = async (userList) => {

        setIsLoading(true);
        try {
            const result = await deleteUserAccount(userList.id, userList.email, userList.ecrp, auth.currentUser.uid);
            if (result.success) {
                // Actualizar el estado para excluir el usuario eliminado
                setUsers(prevUsers => prevUsers.filter(user => user.id !== userList.id));
                props.ShowDone(`Se elimino el usuario: ${userList.email}`);
            } else {
                // Manejar el caso en que la eliminación falla
                props.showErr(`El usuario ${userList.email} no se pudo eliminar.`);
                props.ShowWar(result.message);
            }
            setIsLoading(false);

        } catch (error) {
            console.log(error);
            props.showErr(`El usuario ${userList.email} no se pudo eliminar.`);
            setIsLoading(false);
        }


    };

    // Función para manejar la selección de un usuario
    const handleUserSelect = (user, isSelected) => {
        if (isSelected) {
            setSelectedUsers([...selectedUsers, user]);
        } else {
            setSelectedUsers(selectedUsers.filter(u => u.id !== user.id));
            setSelectAll(false); // Desactivar el checkbox de la cabecera si un usuario se deselecciona
        }
    };

    // Función para manejar el cambio en el checkbox de la cabecera
    const handleSelectAllChange = () => {
        setSelectAll(!selectAll);

        if (!selectAll) {
            setSelectedUsers(currentItems);
        } else {
            setSelectedUsers([]);
        }
    };

    const handleShowModalMulti = () => {
        setShowMultiDeleteModal(true);
        setDropdownOpen({});
    };

    // Función para manejar la eliminación de usuarios seleccionados
    const handleDeleteSelectedUsers = async () => {

        setIsLoading(true);
        try {

            const results = await deleteMultipleUserAccounts(selectedUsers, auth.currentUser.uid);
            const successfulDeletes = results.filter(result => result.success).map(result => result.id);
            const failedDeletes = results.filter(result => !result.success);

            // Actualizar el estado para excluir los usuarios eliminados exitosamente
            setUsers(prevUsers => prevUsers.filter(user => !successfulDeletes.includes(user.id)));

            // Desactivar el checkbox de la cabecera
            setSelectAll(false);

            // Limpiar la lista de usuarios seleccionados
            setSelectedUsers([]);

            // Cerrar el modal una vez que se haya completado la eliminación
            setShowMultiDeleteModal(false);

            if ((successfulDeletes.length === selectedUsers.length) && (successfulDeletes.length > 0)) {
                props.ShowDone(`Se eliminaron ${successfulDeletes.length} usuarios`);
            } else {
                if (successfulDeletes.length > 0) {
                    props.ShowDone(`Se eliminaron ${successfulDeletes.length} usuarios`);
                }

                failedDeletes.forEach(failed => {
                    props.showErr(`El usuario ${failed.email} no se pudo eliminar.`);
                    props.ShowWar(failed.message);
                });
            }
            setIsLoading(false);

        } catch (error) {
            props.showErr('Ocurrio un error inesperado.');
            console.log(error);
            setIsLoading(false);
        }

    };

    const handleModalDelete = (userId) => {
        const userToDelete = users.find(u => u.id === userId);
        if (userToDelete) {
            deleteUsers(userToDelete);
        }
        setShowModalForUserId(null);  // Cerrar el modal
    };


    return (
        <>
            {!loading && (
                <div>
                    < HeaderHome
                        userLoged={useUser}
                    />

                    <div className='bodyHome-user' style={{ height: "210vh" }}>
                        < Menu
                            userLoged={useUser}
                        />
                        <div style={{ width: "100%" }}>
                            <p>Usuarios</p>
                            <div className='filter-users'>
                                <form style={{ width: "70%" }}>
                                    <div className='filter-userDetails'>
                                        <label>Nombre</label>
                                        <label>Correo Electrónico</label>
                                        <label>Rol</label>
                                        <div className="input-with-icon">
                                            <input
                                                id='nombre'
                                                name='nombre'
                                                onChange={InputChangeUsr}
                                                placeholder="Escribe el nombre del usuario"
                                                value={searchName}
                                            />
                                            {searchName && <AiFillCloseCircle className="close-icon-name" onClick={() => {
                                                setSearchName('');
                                                // limpiar local storage
                                                saveFiltersToLocalStorage({
                                                    searchName: '',
                                                    searchEmail,
                                                    searchRole,
                                                    selectedRole
                                                });
                                                document.getElementById('nombre').value = '';
                                            }} />}
                                        </div>
                                        <div className="input-with-icon">
                                            <input
                                                id='email'
                                                name='email'
                                                onChange={InputChangeUsr}
                                                placeholder='Escribe el correo electrónico'
                                                value={searchEmail}
                                            />
                                            {searchEmail && <AiFillCloseCircle className="close-icon-email" onClick={() => {
                                                setSearchEmail('');
                                                // limpiar local storage
                                                saveFiltersToLocalStorage({
                                                    searchName,
                                                    searchEmail: '',
                                                    searchRole,
                                                    selectedRole
                                                });
                                                document.getElementById('email').value = '';
                                            }} />}
                                        </div>
                                        <div className="field-container-usuarios">
                                            <button className="boton-desplegable-usuario" type="button" onClick={() => setRoleOpen(!isRoleOpen)} >
                                                {selectedRole || "Selecciona un rol"}
                                                {isRoleOpen ? <IoIosArrowUp style={{ fontSize: "25px" }} /> : <IoIosArrowDown style={{ fontSize: "25px" }} />}
                                            </button>

                                            {isRoleOpen && (
                                                <div className="dropdown-container-usuarios">
                                                    <ul>
                                                        <li key='12355d'>
                                                            <button className="boton-desplegable-usuario" type="button" onClick={() => handleRoleChange('')}>
                                                                Selecciona un rol
                                                            </button>
                                                        </li>
                                                        {roles.map((role, index) => (
                                                            <li key={index}>
                                                                <button className="boton-desplegable-usuario" type="button" onClick={() => handleRoleChange(role)}>
                                                                    {role}
                                                                </button>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </form>
                                <Link to="/permisos/usuarios/nuevo">
                                    <button>+ Crear Usuario</button>
                                </Link>
                            </div>
                            <div className='delete-users' >
                                <button onClick={handleShowModalMulti} style={{ cursor: "pointer" }}><FiTrash2></FiTrash2> Eliminar</button>
                            </div>
                            {showMultiDeleteModal &&
                                <Modal
                                    selectedUsers={selectedUsers}
                                    initialOpen={true}
                                    close={() => setShowMultiDeleteModal(false)}
                                    onDelete={handleDeleteSelectedUsers}
                                />
                            }
                            <div className='user-details'>
                                <table className='tabla-usuarios'>
                                    <thead>
                                        <tr className='tabla-header'>
                                            <th style={{ paddingTop: "2%", paddingBottom: "2%", paddingLeft: "3%", width: "7%" }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectAll}
                                                    onChange={handleSelectAllChange}
                                                />
                                            </th>
                                            <th style={{ width: "33%" }}>Nombre</th>
                                            <th style={{ width: "22%" }}>Correo</th>
                                            <th style={{ width: "12%" }}>Rol</th>
                                            <th style={{ width: "18%" }}>Ultimo Activo</th>
                                            <th style={{ paddingLeft: "0" }}>Acciones</th>
                                        </tr>
                                        <tr className="separator">
                                            <td colSpan="6"></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.map((user, index) => (
                                            <React.Fragment key={user.id}>
                                                <tr key={user.id} >
                                                    <td style={{ paddingLeft: "3%" }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedUsers.some(u => u.id === user.id)}
                                                            onChange={e => handleUserSelect(user, e.target.checked)}
                                                        />
                                                    </td>
                                                    <td className='tabla-usuario-nombre'>
                                                        <img width={50} className="user-img" src={user.foto || "default-image-url.jpg"} alt={`${user.nombre}'s foto`} />
                                                        {user.nombre}
                                                    </td>
                                                    <td>{user.email}</td>
                                                    <td>{user.rol}</td>
                                                    <td>{formatDate(user.ultimo_log)}</td>
                                                    <td style={{ paddingLeft: "2%" }}>
                                                        <div className='menu-usuarios' ref={dropdownRef} onClick={(e) => e.stopPropagation()}>
                                                            <button className="icon-button" onClick={() => toggleDropdown(user.id)}><CiMenuKebab /></button>

                                                            {!showMultiDeleteModal && dropdownOpen[user.id] && (
                                                                <div className="dropdownMenu">
                                                                    <ul>
                                                                        <li><a className="dontCloseDropdown" onClick={() => goToEditUser(user)}><GrFormEdit></GrFormEdit>Editar</a></li>
                                                                        <li><a className="dontCloseDropdown" onClick={() => { setShowModalForUserId(user.id); setDropdownOpen({}); }}><FiTrash2></FiTrash2>Eliminar</a></li>
                                                                    </ul>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr className="separator">
                                                    <td colSpan="6"></td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                                <div className='paginador-usuarios'>
                                    <span>{currentPage} de {totalPages} </span>
                                    <div>
                                        <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}><MdArrowBackIosNew /> Anterior</button>
                                        {currentPage > 1 && <button onClick={() => paginate(currentPage - 1)}>{currentPage - 1}</button>}
                                        <button style={{ fontWeight: "bold" }} className={currentPage === currentPage ? "selected-page" : ""}>{currentPage}</button>
                                        {currentPage < totalPages && <button onClick={() => paginate(currentPage + 1)}>{currentPage + 1}</button>}
                                        <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>Siguiente <MdArrowForwardIos /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showModalForUserId &&
                <Modal
                    user={users.find(u => u.id === showModalForUserId)}
                    initialOpen={true}
                    close={() => setShowModalForUserId(null)}
                    onDelete={() => handleModalDelete(showModalForUserId)}
                />
            }
            {isLoading && <LoadingModal />}
        </>
    );
}

export default Usuarios;